/**
 * Post-save navigation for mark-as-completed header modals.
 * @module headerModals/utils/navigateToWorklistsAfterMarkComplete
 */

import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { NavigateFunction } from "react-router-dom";
import { ToastMessages } from "../../../../../components/toasts/toastMessages";
import { closeModal } from "../../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../../redux/store/store";
import {
  UserGeneralInfoContextKeys,
  UserStore,
} from "../../../../../store/UserGeneralInfoStore";

/**
 * Closes the active modal, shows success toast, and navigates to the worklists page.
 *
 * @param dispatch - Redux dispatch for closing the modal
 * @param navigate - React Router navigate function
 */
export const navigateToWorklistsAfterMarkComplete = (
  dispatch: AppDispatch,
  navigate: NavigateFunction,
): void => {
  const parentTable =
    UserStore.getItem(UserGeneralInfoContextKeys.PARENT_TABLE) ?? "";
  dispatch(closeModal());
  toast.success(ToastMessages.MARK_AS_COMPLETED_SUCCESS);
  navigate(`/worklists/${parentTable}`);
};
